import { FileClient } from "clients/rest";

export type B100083ExcelRequest = Partial<{
  shireCdFrom: string;
  shireCdTo: string;
  shireshitenCdFrom: string;
  shireshitenCdTo: string;
}>;

export const B100083GetExcel = (props: B100083ExcelRequest) => {
  return FileClient.get("b100083/get/excel", {
    params: props,
  });
};
